import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { marginLeft } from '@/utils/directions';
import { colorText } from '@/utils/palette';

const CompanyTitle = () => {
  const { customerName } = useSelector((state) => state?.customer);

  return (
    <TopbarCompanyWrap>
      <CompanyName>{customerName}</CompanyName>
    </TopbarCompanyWrap>
  );
};

export default CompanyTitle;

export const TopbarCompanyWrap = styled.div`
  display: flex;
  margin-right: 10px;

  @media screen and (max-width: 576px) {
    margin: inherit;
  }

  @media screen and (max-width: 320px) {
    margin: auto 0;
  }
`;

const CompanyName = styled.p`
  margin: auto 0;
  font-size: 13px;
  font-weight: 400;
  ${marginLeft}: 10px;
  color: ${colorText};

  @media screen and (min-width: 480px) {
    display: block;
  }
`;
